import React, {Component} from 'react';
import logo from './logo.svg';
import "./LandingPage.css"

const MAX_DOTS = 5;
const TIMER_DELAY = 500;

class LandingPage extends Component{
    
    timer;
    backgroundCSS;

    constructor(props) {
        super(props);

        this.state = {
            dots: 0
        };
    }

	componentDidMount() {
        this.timer = window.setTimeout(this.handleTimer.bind(this), TIMER_DELAY);
        if (this.props.faded)
            this.backgroundCSS = "landing-background-faded";
        else
            this.backgroundCSS = "landing-background";
	}

	componentWillUnmount() {
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
    }

    handleTimer() {
		this.setState(prevState => ({
            dots: (++prevState.dots % (MAX_DOTS + 1)),
 		}));
   
        this.timer = window.setTimeout(this.handleTimer.bind(this), TIMER_DELAY);
    }

    render() {
		const year = (new Date()).getFullYear();

        const progress = Math.round((this.state.progress || (this.state.dots / MAX_DOTS)) * 100);
		const dots = this.state.dots;
        const status = this.props.status + Array(dots).fill('.').join('') + Array(MAX_DOTS - dots).fill('\u00a0').join('');
        const meterStyles = !this.props.indeterminate ? { width: `${ progress }%` } : null;
        const meterClasses = `progress-meter${ this.props.indeterminate ? ' indeterminate' : '' }`;

        return (
            <div className={this.backgroundCSS}>
                <div className="logo-container">
                    <img className="landing-page-logo" src={logo} alt="Imagine Learning"></img>
                    {
                        this.props.isLoading ? 
                        (<div className="progress">
                            <div className={ meterClasses } style={ meterStyles }></div>
                        </div>)  
                        : (null)                  
                    }                

                    <h5 className="text-center">{status}</h5>
                </div>
                <div className="landing-page-footer">
                    <div className="small-12 columns">
                        <div className="card-footer-links">
                            <span className="copyright-notice">&copy; {year} Imagine Learning, Inc. All Rights Reserved</span>
                            <br />
                            <span className="version-number"><b>Version:</b> {this.props.version}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (LandingPage);


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.js